import React from 'react';
import { Calendar, Clock, User, ArrowRight } from 'lucide-react';

const FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80';

const BlogCard = ({ post, onOpen }) => (
  <article className="bg-slate-800/50 backdrop-blur-sm rounded-xl overflow-hidden border border-slate-700 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl group">
    <div className="aspect-w-16 aspect-h-9 relative overflow-hidden">
      <img
        src={post.image || FALLBACK_IMAGE}
        alt={post.title}
        className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
      />
      <div className="absolute top-4 left-4">
        <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-slate-900 px-3 py-1 rounded-full text-xs font-semibold">
          {post.category || 'Article'}
        </span>
      </div>
    </div>

    <div className="p-6 space-y-4">
      <div className="flex items-center space-x-4 text-xs text-slate-400">
        <div className="flex items-center space-x-1">
          <User size={14} />
          <span>{post.author}</span>
        </div>
        <div className="flex items-center space-x-1">
          <Calendar size={14} />
          <span>{new Date(post.date).toLocaleDateString()}</span>
        </div>
        <div className="flex items-center space-x-1">
          <Clock size={14} />
          <span>{post.readTime}</span>
        </div>
      </div>

      <h3 className="text-xl font-bold text-white leading-tight group-hover:text-amber-400 transition-colors">
        {post.title}
      </h3>

      <p className="text-slate-300 text-sm leading-relaxed">{post.excerpt}</p>

      <button
        onClick={() => onOpen(post)}
        className="inline-flex items-center space-x-2 text-amber-400 hover:text-amber-300 font-semibold transition-colors"
      >
        <span>Read More</span>
        <ArrowRight size={16} />
      </button>
    </div>
  </article>
);

export default BlogCard;
